export interface ModelValidationResult {
  allLoaded: boolean
  missingModels: string[]
}

export async function validateModels(): Promise<ModelValidationResult> {
  const MODEL_BASE = "/models/"
  const requiredModels = [
    "frame_2000x400_open.glb",
    "frame_2000x400_closed.glb",
    "vb_single_2000x1000.glb",
    "vb_double_2000x1000.glb",
    "shelf_970x400_l.glb",
    "shelf_970x400_m.glb",
    "shelf_1270x400_l.glb",
    "shelf_1270x400_m.glb",
  ]

  const missingModels: string[] = []

  for (const model of requiredModels) {
    try {
      const response = await fetch(`${MODEL_BASE}${model}`, { method: "HEAD" })
      if (!response.ok) {
        missingModels.push(model)
      }
    } catch (error) {
      missingModels.push(model)
    }
  }

  return {
    allLoaded: missingModels.length === 0,
    missingModels,
  }
}
